import React, { useState, useMemo } from 'react'
import { MedicalConfirmationModal } from '../../../components/templates/MedicalConfirmationModal'
import { ShortConfirmationModal } from '../../../components/templates/ShortConfirmationModal'
import {
  GigiAlert,
  LowAccuracyAlert,
  ReshapeReport,
} from '../../../types/models/Presc'
import { CheckListIcon } from '../../../icons/CheckListIcon'
import { MedChangeAlert } from '../../../types/models/MedChangeLog'
import { CustomFab } from '../../../components/molecules/CustomFab'
import { useAppType } from '../../../contexts/AppTypeContext'

export const useMedicationAlert = (
  id: string | undefined,
  low_accuracy_alerts: LowAccuracyAlert[] | undefined,
  reshape_reports: ReshapeReport[] | undefined,
  gigi_alerts: GigiAlert[] | undefined,
  med_change_alerts: MedChangeAlert[] | undefined
) => {
  // アラートが存在するかを計算
  const alertExists = useMemo(
    () =>
      !!low_accuracy_alerts?.length ||
      !!gigi_alerts?.length ||
      !!med_change_alerts?.length ||
      !!reshape_reports?.length,
    [low_accuracy_alerts, gigi_alerts, med_change_alerts, reshape_reports]
  )

  // idが変わるたびに、アラートがあればモーダルを開く
  const [modalState, setModalState] = useState<{
    id: string | undefined
    isOpen: boolean
  }>({ id: undefined, isOpen: true })
  const isModalOpen = id === modalState.id ? modalState.isOpen : alertExists
  const setIsModalOpen = (value: boolean) =>
    setModalState({ id, isOpen: value })
  const [isHoverOpen, setIsHoverOpen] = useState(false)

  const { config } = useAppType()
  const isShowHover = config.features.shortConfirmationModal

  const MedicationHover = (
    <ShortConfirmationModal
      isOpen={isHoverOpen}
      gigi_alerts={gigi_alerts}
      reshape_reports={reshape_reports}
      low_accuracy_alerts={low_accuracy_alerts}
      med_change_alerts={med_change_alerts}
    />
  )

  const MedicationModal = (
    <>
      <MedicalConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        setIsHoverOpen={setIsHoverOpen}
        gigi_alerts={gigi_alerts}
        reshape_reports={reshape_reports}
        low_accuracy_alerts={low_accuracy_alerts}
        med_change_alerts={med_change_alerts}
      />
      {isShowHover && MedicationHover}
    </>
  )

  const setMedicationAlertOpen = (value: boolean) => {
    setModalState({ id, isOpen: value })
  }

  return {
    MedicationModal,
    setMedicationAlertOpen,
  }
}

export const medicationAlertOpenButton = (onClick: () => void) => {
  return (
    <CustomFab onClick={onClick}>
      <CheckListIcon />
    </CustomFab>
  )
}
